import React from 'react';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">About Me</h2>
        <div className="about-content">
          <div className="about-text">
            <p>
              I'm a Computer Science graduate with a Master of Science degree from Texas State University, 
              graduating with a GPA of 3.9/4.0. My academic and research work focused on Retrieval-Augmented Generation (RAG) pipelines, 
              GenAI models, and automated code analysis for contract validation and code quality.
            </p>
            <p>
              I have hands-on experience developing full-stack applications and have worked on projects ranging from 
              ML contract violation detection to secure banking systems. As a former Graduate Research Assistant, I explored 
              advanced prompting strategies and runtime contract validation methodologies. I'm AWS Cloud Practitioner certified 
              and passionate about building scalable, reliable software solutions. Currently seeking software development, 
              software engineering, and full-stack development opportunities.
            </p>
            <div className="about-stats">
              <div className="stat-item">
                <h3>3.9</h3>
                <p>GPA (MS in CS)</p>
              </div>
              <div className="stat-item">
                <h3>AWS</h3>
                <p>Cloud Certified</p>
              </div>
              <div className="stat-item">
                <h3>2+</h3>
                <p>Years Experience</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

